import { styled } from '@mui/material/styles'
import { hexToCSSFilter } from 'utils/hex-to-css-filter'

const BackgroundImage = styled('div')<{ filterColor?: string; imageUrl: string }>`
    background: url(${(props) => props.imageUrl});
    mask-image: linear-gradient(to left, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0) 50%, rgba(0, 0, 0, 0) 100%);
    background-repeat: no-repeat;
    background-position: right;
    background-size: cover;
    position: absolute;
    height: 100%;
    width: 100%;
    z-index: -1;
    opacity: 0.6;

    ${(props) => (props.filterColor ? hexToCSSFilter(props.filterColor) : undefined)};

    ${({ theme }) => theme.breakpoints.down('md')} {
        opacity: 0.2;
    }
`

export default BackgroundImage
